<template>
  <div class="home">
  <my-layout>
    <!-- 插入主内容区的内容 -->
    <template v-slot:main>
      <p style="text-align: center;">
        <img src="@/assets/newLog.png" alt="" style="width: 35%; height: 35%;">
      </p>

      <p class="description">An easy-to-use Python framework to generate adversarial jailbreak prompts by assembling different methods</p>
      <p class="dynamic">{{describe}}</p>

      <el-table  class="main_table"
              :data="tableDb"
              border
              style="width: 100%">
        <el-table-column
                prop="Model"
                label="Model">
        </el-table-column>

        <el-table-column width="135" label="ReNeLLM" prop="ReNeLLM" sortable>
          <template slot="header" slot-scope="{column}">
            <span class="field_head" @click="goDetails(column.property)">{{column.label}}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="GPTFuzz" width="125"
                sortable
                label="GPTFuzz">
          <template slot="header" slot-scope="{column}">
            <span class="field_head" @click="goDetails(column.property)">{{column.label}}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="ICA" width="120"
                sortable
                label="ICA">
          <template slot="header" slot-scope="{column}">
            <span class="field_head" @click="goDetails(column.property)">{{column.label}}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="AutoDAN" width="135"
                sortable
                label="AutoDAN">
          <template slot="header" slot-scope="{column}">
            <span class="field_head" @click="goDetails(column.property)">{{column.label}}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="PAIR" width="120"
                sortable
                label="PAIR">
          <template slot="header" slot-scope="{column}">
            <span class="field_head" @click="goDetails(column.property)">{{column.label}}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="JailBroken"  width="150"
                sortable
                label="JailBroken">
          <template slot="header" slot-scope="{column}">
            <span class="field_head" @click="goDetails(column.property)">{{column.label}}</span>
          </template>
        </el-table-column>

        <el-table-column
                prop="Cipher" width="120"
                sortable
                label="Cipher">
          <template slot="header" slot-scope="{column}">
            <span class="field_head" @click="goDetails(column.property)">{{column.label}}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="JailBroken"  width="155"
                sortable
                label="JailBroken">
          <template slot="header" slot-scope="{column}">
            <span class="field_head" @click="goDetails(column.property)">{{column.label}}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="DeepInception"  width="175"
                sortable
                label="DeepInception">
          <template slot="header" slot-scope="{column}">
            <span class="field_head" @click="goDetails(column.property)">{{column.label}}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="MultiLingual"   width="155"
                sortable
                label="MultiLingual">
          <template slot="header" slot-scope="{column}">
            <span class="field_head" @click="goDetails(column.property)">{{column.label}}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="GCG"   width="120"
                sortable
                label="GCG">
          <template slot="header" slot-scope="{column}">
            <span class="field_head" @click="goDetails(column.property)">{{column.label}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="Avg"  width="120"
            sortable
            label="Avg">
          <template slot="header" slot-scope="{column}">
            <span class="field_head" @click="goDetails(column.property)">{{column.label}}</span>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </my-layout>
  </div>
</template>

<script>
    import MyLayout from '@/views/MyLayout.vue'
    import staticDb from '../db/staticDb.js'
    export default {
        name: 'App',
        components: {
          MyLayout
        },
        data() {
          return {
            describe:`EasyJailbreak is an easy-to-use Python framework designed for researchers and developers focusing on LLM security. Specifically, EasyJailbreak decomposes the mainstream jailbreaking process into several iterable steps: initialize mutation seeds, select suitable seeds, add constraint, mutate, attack, and evaluate. On this basis, EasyJailbreak provides a component for each step, constructing a playground for further research and attempts. More details can be found in our paper. `,
            tableDb: staticDb.mainTableDb
          };
        },
        methods:{
          goDetails(fn){
            console.log(`/details/${fn}`)
            this.$router.push({
              path:`/details/${fn}`
            })
          }
        },
      created(){}
    };
</script>

<style lang="scss" scoped>
  .home{
    .txt{font-size: 44px; font-weight: bold; color:#f00}
  }
  .main_table{
    .field_head:hover{text-decoration: underline; color:#409eff}
    .el-table__cell{min-width: 120px;}
  }

  /* 标题段落的样式 */
  .title {
    font-size: 28px;
    font-weight: bold;
    color: #333;
    text-align: center; /* 设置文本居中 */
    margin-bottom: 8px;
  }

  /* 描述段落的样式 */
  .description {
    font-size: 16px;
    color: #666;
    text-align: center; /* 设置文本居中 */
    margin-top: 0; /* 删除顶部间距 */
    margin-bottom: 16px;
  }

  /* 动态内容段落的样式 */
  .dynamic {
    font-style: italic;
    color: #000000;
    font-size: 18px;
    text-align: center; /* 设置文本居中 */
    word-wrap: break-word; /* 自动换行 */
    margin: 0 auto; /* 水平居中 */
    max-width: 60%; /* 设置最大宽度，以防止内容过宽 */
  }
  /* 表格容器的样式 */
  .main_table {
    background-color: #f3c5c5; /* 设置背景色为淡红色 */
    color: #333; /* 设置文字颜色为深灰色 */
  }

  /* 表头的样式 */
  .el-table th {
    background-color: #f7f7f7; /* 设置表头背景色为浅灰色 */
    color: #333; /* 设置表头文字颜色为深灰色 */
  }

  /* 表格行的样式（奇数行） */
  .el-table-row:nth-child(odd) {
    background-color: #f7f7f7; /* 设置奇数行背景色为浅灰色 */
  }

  /* 表格行的样式（偶数行） */
  .el-table-row:nth-child(even) {
    background-color: #f3c5c5; /* 设置偶数行背景色为淡红色 */
  }

  /* 表头排序图标的颜色 */
  .el-icon-caret-top, .el-icon-caret-bottom {
    color: #333; /* 设置排序图标颜色为深灰色 */
  }

  /* 表格中的链接文字颜色 */
  .field_head {
    color: #ff0000; /* 设置链接文字颜色为红色 */
    cursor: pointer;
  }

</style>
